import { Canvas } from 'fabric';

import IconCursor from 'approot/shared/inline-svg/activity-builder/icon-cursor';
import { Tool } from '../draw-canvas.constants';
import { ToolBarTool } from './toolbar.style';
import { useDrawCanvasContext } from '../draw-canvas.context';
import ToolbarItem from './toolbar-item';

type Props = {
  canvas?: Canvas | null;
};

const ToolbarItemSelect = ({ canvas }: Props) => {
  const { toolSet, setToolSet, turnOffDrawMode } = useDrawCanvasContext();

  return (
    <ToolbarItem hoverText="Select">
      <ToolBarTool
        $isActive={toolSet?.tool === Tool.Select}
        onClick={() => {
          if (canvas) {
            turnOffDrawMode(canvas);
            setToolSet({ tool: Tool.Select });
          }
        }}
      >
        <IconCursor width={24} height={24} />
      </ToolBarTool>
    </ToolbarItem>
  );
};
export default ToolbarItemSelect;
